// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var ChargebackFeeController = function ($scope, ChargebackFee, UpgradeFees, gettext, gettextCatalog,
                                        ChargebackFeeDownloadByFilter, DatepickerUtils) {    
    var _txt = function (msg) {
        return gettextCatalog.getString(msg);
    };
    $scope.wasSearching = false;
    $scope.Fees = new UpgradeFees();
    $scope.updateFees = function (bill) {
        var bill_txt = _txt(gettext('Do you want to bill the fee(s)?'));
        var dont_bill_txt = _txt(gettext('Do you want to skip billing the fee(s)?'));
        var heading_txt = _txt(gettext('Handling Fees'));

        $scope.yesCancel(heading_txt, bill ? bill_txt : dont_bill_txt, function () {
            SaveCommonRule(bill);
        });
    };
    function SaveCommonRule(bill) {
        $scope.Fees.Bill = bill;
        $scope.Fees.OpenOnly = $scope.onlyOpen;
        $scope.Fees.Filter = $scope.search;
        $scope.Fees.From = $scope.dateRange.dateFrom;
        $scope.Fees.To = $scope.dateRange.dateTo;
        $scope.Fees.$save({}, function() { $scope.updateFilter(); });
    }

    $scope.dateRange = { dateFrom: null, dateTo: null };

    $scope.updateFilter = function (func) {
        $scope.chargebackFees = $scope.paginator(function (options, callback) {
            return ChargebackFee.query(options, function () { callback(); $scope.wasSearching = options.search;
                if (func)
                {
                    func();
                    func = null;
                }
            });
        }, getSearchParams(), 20);
    };

    var getSearchParams = function () {
        return {
            search: $scope.search,
            dateFrom: $scope.dateRange.dateFrom,
            dateTo: $scope.dateRange.dateTo,
            onlyOpen: $scope.onlyOpen
        };
    };
    
    $scope.setShouldBeBilled = function (chargebackFeeId, status) {
        var chargebackFee = ChargebackFee.get({ id: chargebackFeeId }, function () {
            if (chargebackFee.HasBeenBilled)
                return;
            chargebackFee.ShouldBeBilled = status;
            chargebackFee.$update({ id: chargebackFee.Id }, function () {
                $scope.updateFilter();
            });
        });
    };
    
    $scope.downloadByFilter = function () {
        var searchParams = getSearchParams();
        searchParams.isDownload = true;
        var download = function () {
            $scope.isL = true;
            var downloadInfo = new ChargebackFeeDownloadByFilter();
            downloadInfo.$save({
                isDownload: true,
                dateFrom: searchParams.dateFrom,
                dateTo: searchParams.dateTo,
                search: searchParams.search,
                onlyOpen: searchParams.onlyOpen
            }, function () {
                window.location = downloadInfo.Url;
                $scope.isL = false;
            }, function () { $scope.isL = false; });
        };
        $scope.updateFilter(download);
    };

    $scope.filter = "";
    $scope.search = "";
    $scope.updateFilter();
};
ChargebackFeeController.$inject = ['$scope', 'ChargebackFee', 'UpgradeFees', 'gettext', 'gettextCatalog',
    'ChargebackFeeDownloadByFilter', 'DatepickerUtils'];
